/**
 * 작성자 : 홍선영
 * 날짜 : 2025.09.05
 * 경로 : (본사) 방문자 관리 - 방문자 설정 관리
 */

import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useOutletContext } from 'react-router-dom';

import { IUser, pageInfoState, themeState, userState } from '../../atoms';
import { ITabObject } from 'customTypes';
import { VIDEO_TYPE_VISITOR } from '../../_constants';
import Tab from '../../components/Tab';
import SafeEduExamSetting from '../../components/SafeEduExamSetting';
import JobtypeVideo from '../../components/JobtypeVideo';
import InputList from '../../components/InputList';
import EdutermSetting from '../sm_setting/setting13/EdutermSetting';
import QrCode from '../../components/QrCode';
import SafeEduForm from '../sm_setting/setting13/SafeEduListForm';
import hGuideL from '../../assets/images/common/h_guide_l.png';
import hGuideD from '../../assets/images/common/h_guide_d.png';
import { useTranslation } from 'react-i18next';

const Hvisitor2 = () => {
  const { t } = useTranslation();
  const isTheme = useRecoilValue(themeState); // 테마 상태
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const userInfo = useRecoilValue<IUser>(userState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { userMenuList } = userInfo;
  const PURPOSE = { type: 'purpose', endPoint: '/visit/purpose', dtoKey: 'visitPurposeReqDto', nameKey: 'pName', codeKey: 'pCd', responseArrayKey: '' };
  const DEPT = { type: 'dept', endPoint: '/visit/dept', dtoKey: 'visitDeptReqDto', nameKey: 'deptName', codeKey: 'deptCd', responseArrayKey: '' };

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList //
        ?.find(
          (el: ITabObject) =>
            el.mtCd === v.mtCd && //
            el.mdCd === v.mdCd &&
            el.mrCd === v.mrCd
        );
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = userMenuList.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    const { sCd } = userInfo;

    // 본사 메인일 경우 가이드 표시
    if (sCd === '00000') {
      return (
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', flexDirection: 'column' }}>
          <img src={isTheme === 'dark' ? hGuideD : hGuideL} alt='현장 선택 가이드' style={{ width: '100%', maxWidth: '580px', borderRadius: '1rem' }} />
          <p style={{ padding: '0.5rem 0.75rem', backgroundColor: 'var(--tonal-violet)', color: 'var(--filled-violet)', borderRadius: '0.25rem' }}>{t('좌측 사이드바 상단에 현장명을 선택해주세요')}</p>
        </div>
      );
    }

    // 본사에서 현장 선택시 보여지는 페이지
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <JobtypeVideo sType={VIDEO_TYPE_VISITOR} />; // 동영상 설정
        case '002':
          return <SafeEduExamSetting examType='VISITOR' />; // 문답 설정
        case '003':
          return <InputList prop={DEPT} />; // 부서 설정
        case '004':
          return <InputList prop={PURPOSE} />; // 목적 설정
        case '005':
          return <EdutermSetting />; // 기타 설정
        case '006':
          return <QrCode />; // QR 코드
        case '007':
          return <SafeEduForm />;
      }
    }
    return null;
  };

  return (
    <div className='contents'>
      <Tab
        tabList={newTabList || tabInfo.tabList} //
        currentTabMrCd={currentTabMrCd}
        setCurrentTabMrCd={setCurrentTabMrCd}
        onClickTab={onClickTab}
        size={size}
      />
      {renderPage()}
    </div>
  );
};

export default Hvisitor2;
